<template>
    <div class="tabs">
        <nav>
            <ul>
                <li>
                    <menu-tabs-item routing="ask-for-quote.client-quote" :askForQuoteId="askForQuoteId" :state="askForQuoteStatus > 1 ? true : false">
                        K-Anfrage
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.classification" :askForQuoteId="askForQuoteId" :state="askForQuoteStatus > 2 ? true : false">
                        Klassifizierung
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.producer-quote" :askForQuoteId="askForQuoteId" :state="askForQuoteStatus > 3 ? true : false">
                        P-Anfrage
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.producer-offer" :askForQuoteId="askForQuoteId" :state="askForQuoteStatus > 4 ? true : false">
                        P-Angebot
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.client-offer" :askForQuoteId="askForQuoteId" :state="askForQuoteStatus > 5 ? true : false">
                        K-Angebot
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.confirmation" :state="askForQuoteStatus > 8 ? true : false" :stateHalf="askForQuoteStatus > 6 ? true : false" :askForQuoteId="askForQuoteId">
                        Bestätigung
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.delivery" :state="askForQuoteStatus > 10 ? true : false" :stateHalf="askForQuoteStatus > 9 ? true : false" :askForQuoteId="askForQuoteId">Lieferung
                    </menu-tabs-item>
                </li>
                <li>
                    <menu-tabs-item routing="ask-for-quote.order-information" :state="askForQuoteStatus > 11 ? true : false" :stateHalf="askForQuoteStatus > 10 ? true : false" :askForQuoteId="askForQuoteId">
                        Auftragsdaten
                    </menu-tabs-item>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import MenuTabsItem from './MenuTabsItem';

export default {
    name: 'MenuTabs',
    components: {MenuTabsItem},
    props: [
        'askForQuoteId',
        'askForQuoteStatus',
    ],
};
</script>
